var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _path6, _path7, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMascoteBioailab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    width: 120,
    height: 120,
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Assistente BioAILab") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "corpo",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8CBCF7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    style: {
      stopColor: "#4A93F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F80ED"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      stroke: "#1E3A5F",
      strokeWidth: 3.4,
      strokeLinecap: "round"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47 104 q-2 7 -8 12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58 106 q0 6 -1 11"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70 105 q3 7 9 11"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38 75 q-14 0 -14 -22"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79 88 C 90 97, 103 97, 106 88"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 14,
    width: 46,
    height: 92,
    rx: 23,
    style: {
      fill: "url(#corpo)",
      stroke: "#1E3A5F",
      strokeWidth: 2.6
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50,
    cy: 24,
    rx: 7,
    ry: 4,
    style: {
      fill: "#FFFFFF",
      opacity: 0.32
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 27,
    r: 1.8,
    style: {
      fill: "#C7DEFB",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 52,
    cy: 45,
    rx: 2.9,
    ry: 3.6,
    style: {
      fill: "#14233B"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 66,
    cy: 45,
    rx: 2.9,
    ry: 3.6,
    style: {
      fill: "#14233B"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 43.7,
    r: 1,
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 43.7,
    r: 1,
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 60.5 q6 4.4 12 0",
    style: {
      fill: "none",
      stroke: "#14233B",
      strokeWidth: 2.4,
      strokeLinecap: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6 66 H50 L59 82 L68 66 H81.4 V92 Q81.6 99 84.5 102 H33.5 Q36.4 99 36.6 92 Z",
    style: {
      fill: "#FFFFFF",
      stroke: "#1E3A5F",
      strokeWidth: 2.2,
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      stroke: "#C3D3E8",
      strokeLinecap: "round"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.5 66.8 L55 81.5",
    style: {
      strokeWidth: 1.6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5 66.8 L63 81.5",
    style: {
      strokeWidth: 1.6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 84 V100.5",
    style: {
      strokeWidth: 1.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5 80 h10 v7 a1.5 1.5 0 0 1 -1.5 1.5 h-7 a1.5 1.5 0 0 1 -1.5 -1.5 z",
    style: {
      strokeWidth: 1.4
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44 80.5 v-4.5",
    style: {
      fill: "none",
      stroke: "#2F80ED",
      strokeWidth: 2,
      strokeLinecap: "round"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#C3D3E8"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 88,
    r: 1.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 95,
    r: 1.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-12 24 52)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 29,
    width: 7,
    height: 29,
    rx: 3.5,
    style: {
      fill: "rgba(255, 255, 255, 0.62)",
      stroke: "#7FB6F2",
      strokeWidth: 1.6
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.6,
    y: 44,
    width: 4.8,
    height: 12.9,
    rx: 2.4,
    style: {
      fill: "#F2C94C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 33 v8",
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 1.3,
      strokeLinecap: "round",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 25,
    width: 9,
    height: 6.5,
    rx: 1.6,
    style: {
      fill: "#2BA59B"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 52,
    r: 2.8,
    style: {
      fill: "#1E3A5F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(8 89 80)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.5,
    y: 60,
    width: 31,
    height: 41,
    rx: 5,
    style: {
      fill: "#1E3A5F",
      stroke: "#1E3A5F",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 64.5,
    width: 24,
    height: 31,
    rx: 2,
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77 70 v-3.5 a2 2 0 0 1 2 -2 h20 a2 2 0 0 1 2 2 v3.5 z",
    style: {
      fill: "#2F80ED"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 78.6,
    y: 68.55,
    style: {
      fontFamily: "Manrope, 'Segoe UI', system-ui, sans-serif",
      fontSize: "3.2px",
      fontWeight: 800,
      fill: "#FFFFFF",
      letterSpacing: "0.02em"
    }
  }, "BioAILab"), /*#__PURE__*/React.createElement("circle", {
    cx: 98.9,
    cy: 67.3,
    r: 0.7,
    style: {
      fill: "#9FE3D8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.6,
    y: 71.6,
    width: 11,
    height: 1.1,
    rx: 0.55,
    style: {
      fill: "#C9D6E8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.6,
    y: 74,
    width: 20.8,
    height: 13.2,
    rx: 1,
    style: {
      fill: "#F1F6FD"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      stroke: "#DCE6F3",
      strokeWidth: 0.3
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80 77.2 H98.6 M80 80.4 H98.6 M80 83.6 H98.6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6 75.2 V86.2 M89.2 75.2 V86.2 M93.8 75.2 V86.2"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M80 75.2 V86.2 H98.6",
    style: {
      fill: "none",
      stroke: "#A9BCD4",
      strokeWidth: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 81.8 H98.6",
    style: {
      fill: "none",
      stroke: "#E0A43A",
      strokeWidth: 0.4,
      strokeDasharray: "1 0.7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4 85.6 C 85.5 85.6 87 76.6 98.2 76.1 L98.2 86.2 L80.4 86.2 Z",
    style: {
      fill: "#2F80ED",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4 85.6 C 85.5 85.6 87 76.6 98.2 76.1",
    style: {
      fill: "none",
      stroke: "#2F80ED",
      strokeWidth: 0.9,
      strokeLinecap: "round"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2F80ED",
      strokeWidth: 0.35
    }
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.1,
    cy: 85.2,
    r: 0.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.6,
    cy: 83.4,
    r: 0.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 81,
    r: 0.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.4,
    cy: 78.4,
    r: 0.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.1,
    cy: 76.5,
    r: 0.5
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 78.6,
    y: 89.2,
    width: 10.5,
    height: 1,
    rx: 0.5,
    style: {
      fill: "#C9D6E8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.6,
    y: 91.3,
    width: 7,
    height: 1.4,
    rx: 0.7,
    style: {
      fill: "#A9BCD4"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.6,
    y: 93.3,
    width: 8.5,
    height: 0.9,
    rx: 0.45,
    style: {
      fill: "#2BA59B",
      opacity: 0.7
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97.4,
    cy: 91.6,
    r: 2,
    style: {
      fill: "#2BA59B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4 91.6 l0.75 0.75 l1.35 -1.4",
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 62.2,
    r: 0.9,
    style: {
      fill: "#8FA6C4"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 104.2,
    cy: 86.4,
    r: 2.8,
    style: {
      fill: "#1E3A5F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.5,
    y: 40.5,
    width: 5.5,
    height: 10,
    rx: 2,
    style: {
      fill: "#1E3A5F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 40.5,
    width: 5.5,
    height: 10,
    rx: 2,
    style: {
      fill: "#1E3A5F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 35.5,
    width: 54,
    height: 20,
    rx: 9,
    style: {
      fill: "rgba(214, 236, 255, 0.42)",
      stroke: "#7FB6F2",
      strokeWidth: 2.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 41.5 q2.5 -3 7.5 -3.2",
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 2,
      strokeLinecap: "round",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5 49 q-1.2 2 -3.6 2.6",
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 1.6,
      strokeLinecap: "round",
      opacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#7FB6F2"
    }
  }, _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 38.2,
    r: 0.85
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 38.2,
    r: 0.85
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 38.2,
    r: 0.85
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMascoteBioailab);
export default __webpack_public_path__ + "static/media/mascote-bioailab.bfbb355474ad3becdbd9751b70554098.svg";
export { ForwardRef as ReactComponent };